export const mgPlatformChartIncreaseBigIcon = {
  data: `<svg viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.985 81.0366C66.8747 81.0366 79.6599 49.6937 79.6599 27.7966V8.90496M79.6599 8.90496L64.2031 26.0792M79.6599 8.90496L95.1167 26.0792M2.37598 2.03528V101.646H101.986" stroke="currentColor" stroke-width="3.92553" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'chart-increase-big'
}
